module.exports = __webpack_public_path__ + "img/high-1.e53db510.svg";